import { createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IEecsFee } from '../types/eecs-fees.types';

export interface EecsFeesInitialState extends BaseDataReducerV2InitialState<IEecsFee> {}

const { initialState, AC, reducer, thunks } = basedDataReducerV2<IEecsFee, EecsFeesInitialState>('eecs-fees');

export const eecsFeesInitialState: EecsFeesInitialState = {
  ...initialState,
  perPage: 25,
};

export const eecsFees = createSlice({
  name: 'eecsFees',
  initialState: eecsFeesInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as EecsFeesInitialState, action);
    });
  },
});

export const EecsFeesAC = AC;
export const onEecsFeesSort = thunks.onSort;
export const onEecsFeesFilter = thunks.onFilter;
export const clearEecsFeesFilters = AC.clearFilters;
export const setEecsFeesCurrentPage = AC.setCurrentPage;
